import { http } from "./http";
import { GET_SALES_GOAL_LIST_URL, SAVE_SALES_GOAL_URL, UPDATE_SALES_GOAL_URL } from "./URL";

export type SalesGoalPayload = {
  salesGoalId?: number;
  year: number;
  month: string;
  invoiceYear: number;
  collectionTarget: number;
  actualCollectedAmt?: number | null;
  achievementPct?: number | null;
};

export const getSalesGoalList = async (payload: Record<string, unknown> = {}) => {
  const response = await http.post(GET_SALES_GOAL_LIST_URL, payload);
  return response;
};

const skipGlobalErrorPopup = { skipErrorPopup: true };

export const saveSalesGoal = async (payload: SalesGoalPayload) => {
  const response = await http.post(SAVE_SALES_GOAL_URL, payload, undefined, skipGlobalErrorPopup);
  return response;
};

export const updateSalesGoal = async (payload: SalesGoalPayload) => {
  const response = await http.post(UPDATE_SALES_GOAL_URL, payload, undefined, skipGlobalErrorPopup);
  return response;
};
